export enum ECertifikatAktivita {
    K = 'K',
    A = 'A',
    DN = 'DN',
    D = 'D',
    KM = 'KM',
    M = 'M',
    I = 'I',
    UM = 'UM',
    O = 'O'
}
